export default {
    'ERROR-SEND-LOGIN-ADMIN-SAAS': {
        'USER-NOT-FOUND': {
            actionType: '',
            message: {
                fr: "Utilisateur non trouvé.",
                en: 'User not found.',
            },
        },
        'USER-NOT-ADMIN-NOT-SUPER-ADMIN': {
            actionType: '',
            message: {
                fr: "L'utilisateur n'est ni administrateur, ni super administrateur.",
                en: 'User is neither admin nor super admin.',
            },
        },
        'ORGANIZATION-NOT-FOUND': {
            actionType: '',
            message: {
                fr: "Organisation non trouvée.",
                en: 'Organization not found.',
            },
        },
    },
};
